import { Grid } from "@mui/material"
import { FC, ReactNode } from "react"

export const InputGrid: FC<{children: ReactNode, minWidth?: number}> = ({children, minWidth = 3}) => {
    // Here sx has value of 6 because in very smaller screens also we can show 2 input fields at one line. If we need to change this we can set this to 12 for xs.
    return <Grid justifyContent="center" item xs={Math.max(minWidth, 6)} sm={Math.max(minWidth,6)} md={Math.max(minWidth,4)} lg={Math.max(minWidth,3)} padding={1}>
        {children}
    </Grid>
}